<template>
    <div class="related-course">
        <div class="related-lecture">
            <div class="title">관련동화</div>
            <div class="button">
                <img v-show="isTwoTrackVisible" v-if="!isTwoTrack" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/twotrack.png" width="80" height="25" @click="twoTrack" />
                <img v-show="isTwoTrackVisible" v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/twotrack-active.png" width="80" height="25" @click="twoTrack" />
                <img v-if="!isAutoPlay" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/autoplay.png" width="80" height="25" @click="autoPlay" />
                <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/autoplay-active.png" width="80" height="25" @click="autoPlay" />
            </div>
        </div>
        <ul class="related-lecture-list">
            <li class="item-group" v-for="course in relatedCourseList" :key="course">
                <div class="lecture-image" @click="play(course)">
                    <img v-bind:src="course.related_course_thumb_url" width="72" height="72" />
                    <img class="play-image" src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/lecture-white-player.png" width="16" height="16" />
                </div>
                <div class="item-content">
                    <div class="course-name word_comma_1" @click="play(course)">{{ course.related_course_name }}</div>
                    <div class="teacher-info">{{ course.related_teacher_name }}<span> · {{ course.related_teacher_div_name }}</span><span v-if="course.course_div === '10'"> · 투트랙</span></div>
                    <div class="lecture-info">
                        <div class="subject" v-if="course.lecture_div === '20'">{{ course.related_plan_subject_name }}</div>
                        <div class="subject">{{ course.related_subject_name }}</div>
                        <div v-if="course.related_school_div === '10'" class="school">{{ course.related_school_div_name | convertSchoolGrade }}</div>
                        <div v-if="course.related_school_div === '20'" class="school-mid">{{ course.related_school_div_name | convertSchoolGrade }}</div>
                        <div v-if="course.related_school_div === '99'" class="school-hig">{{ course.related_school_div_name | convertSchoolGrade }}</div>
                        <div class="lecture-view">
                            <div class="time"><img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/lecture-clock.png" width="10" height="10" />{{ course.related_course_time }}</div>
                            <div class="count">
                                <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/player/lecture-view.png" width="14" height="10" />{{ course.related_view_count | thousandSeparator }}</div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import * as utils from "../../utils/utils";
    import * as biz from '../../utils/biz'

    export default {
        name: 'RelatedCourse',
        props: {
            courseNo: Number
        },
        data() {
            return {
                relatedCourseList: [
                    {
                        course_no: 1,
                        course_div: "20",
                        related_course_no: 0,
                        related_course_name: "1강 지구의 자전은 무엇일까?",
                        related_course_thumb_url: "",
                        thumb_url: "https://ba8hb5guu4.ecn.cdn.ofs.kr/images/content/course/201908/da2302a0d96147c5b40d43e5e94782cf.png",
                        teacher_name: "홍길동",
                        teacher_div_name: "대학생",
                        subject_name: "과학",
                        school_div_name: "중등",
                        course_time: 180,
                        view_count: 1130,
                        related_teacher_name: "",
                        related_teacher_div_name: "",
                        related_subject_name: "",
                        related_school_div_name: "",
                        related_course_time: 180,
                        related_view_count: 0
                    }
                ],
                isTwoTrack: false,
                isAutoPlay: false
            }
        },
        mounted() {
        },
        methods: {
            twoTrack() {
                this.isTwoTrack = !this.isTwoTrack;
            },
            autoPlay() {
                this.isAutoPlay = !this.isAutoPlay;
            },
            play(courseInfo) {
                biz.playAudioPlayer(courseInfo.related_course_no);
                // 재생 시 화면 맨 위로
                document.querySelector('div.basic-player').scrollTop = 0;
            },
            playEnded() {
                // Two Track 이 활성회 되어 있는 경우에는 Two Track 재생 : 우선순위 1번
                if (this.isTwoTrack) {
                    let relatedCourseNo = false;
                    for (const item of this.relatedCourseList) {
                        if (item.course_div === "10") {
                            relatedCourseNo = item.related_course_no;
                            break;
                        }
                    }
                    this.isTwoTrack = false;
                    biz.playAudioPlayer(relatedCourseNo);
                    return;
                }

                // 자동재생이 활성화 되어 있는 경우에는 다음동화 중에서 다음 곡 재생
                if (this.isAutoPlay) {
                    let relatedCourseNo = false;
                    for (const item of this.relatedCourseList) {
                        if (item.course_div === "20") {
                            relatedCourseNo = item.related_course_no;
                            break;
                        }
                    }
                    biz.playAudioPlayer(relatedCourseNo);
                }
            }
        },
        computed: {
            isTwoTrackVisible() {
                let visible = false;

                for (const item of this.relatedCourseList) {
                    // Two Track 동화가 있는 경우에만 보임.
                    if (item.course_div === "10") {
                        visible = true;
                        break;
                    }
                }
                return visible;
            }
        },
        watch: {
            'courseNo': function(val, oldVal) {
                ajax.Get(this, "/api/contents/relate/" + val, function(ref, data) {
                    for (let key in data) {
                        if (data[key].related_course_code !== null)
                            data[key].related_school_div_name += data[key].related_school_grade_name.replace(/학년/gi, "");
                    }
                    
                    //ref.relatedCourseList = data;
                    ref.relatedCourseList = data.filter(data => data.related_course_no !== null)
                });
            }
        },
        filters: {
            minuteToStringFormat(value) {
                return utils.minuteToStringFormat(value);
            },
            thousandSeparator(value) {
                return utils.thousandSeparator(value);
            },
            convertSchoolGrade(value) {
                return utils.convertSchoolGrade(value);
            }
        },
    }
</script>

<style scoped lang="scss">
    div.related-course {
        padding: 25px 24px;
    }

    div.related-lecture {
        margin: 0 auto;
        display: flex;

        div.title {
            width: 40%;
            font-weight: $font-weight500;
        }

        div.button {
            width: 60%;
            display: flex;
            justify-content: flex-end;

            img:first-child {
                margin-right: 4px;
            }
        }
    }

    ul.related-lecture-list {
        list-style: none;
        padding: 0;
        margin: 20px 0;

        li.item-group {
            display: flex;
            height: 72px;
            margin-top: 16px;

            div.lecture-image {
                img.play-image {
                    position: relative;
                    top: -47px;
                    left: -23px;
                }
            }

            div.item-content {
                flex: 1;
                width: 227px;

                div.course-name {
                    font-size: $font-base14;
                    font-weight: $font-weight500;
                    margin: 4px 0 6px 0;
                }

                div.teacher-info {
                    font-size: $font-base12;
                    margin-bottom: 4px;

                    span {
                        color: $font-third-color;
                    }
                }

                div.lecture-info {
                    display: flex;
                    font-size: $font-base10;

                    .subject {
                        height: 18px;
                        margin-right: 2px;
                        padding: 0 6px;
                        border: 1px solid $fifth-color;
                        border-radius: 18px;
                        text-align: center;
                        font-weight: 400;
                        color: $fifth-color;
                    }

                    .school {
                        height: 18px;
                        padding: 0 6px;
                        border: 1px solid $primary-color;
                        border-radius: 18px;
                        text-align: center;
                        font-weight: 400;
                        color: $primary-color;
                    }
                    div.school-mid {
                        float: left;
                        height: 18px;
                        padding: 0 6px;
                        border: 1px solid $sixth-color;
                        border-radius: 18px;
                        line-height: 16px;
                        text-align: center;
                        font-size: $font-base10;
                        font-weight: 400;
                        color: $sixth-color;
                    }
                    div.school-hig {
                        float: left;
                        height: 18px;
                        padding: 0 6px;
                        border: 1px solid $font-fifth-color;
                        border-radius: 18px;
                        line-height: 16px;
                        text-align: center;
                        font-size: $font-base10;
                        font-weight: 400;
                        color: $font-fifth-color;
                    }
                    .lecture-view {
                        flex: auto;
                        justify-content: flex-end;
                        display: flex;

                        font-size: $font-base12;
                        color: $font-third-color;

                        .time {
                            width: 48px;
                            img {
                                margin-right: 5px;
                            }
                        }
                        .count {
                            width: 48px;
                            margin-left: 10px;
                            img {
                                margin-right: 5px;
                            }
                        }
                    }
                }
            }
        }
    }

    div.related-lecture-button {
        margin: 20px 0;
        text-align: center;
        font-size: $font-base14;
        color: #5b5a5a;
        padding-top: 13px;
        border-top: 1px solid #ececec;

        ion-icon {
            margin-left: 8px;
        }
    }
</style>
